import Directory from '@/model/Directory';
import FileFactory from '@/factories/FileFactory';

class DirectoryFactory
{
	public static create(parent: Directory, options: any)
	{
		const directory = new Directory(options);

		directory.parent = parent;

		if (options.children && options.children.length > 0)
		{
			for (const directoryOptions of options.children)
			{
				const childDirectory = this.create(directory, directoryOptions);

				directory.children.push(childDirectory);
			}
		}

		if (options.files && options.files.length > 0)
		{
			for (const fileOptions of options.files)
			{
				const file = FileFactory.create(directory, fileOptions);

				directory.files.push(file);
			}
		}

		return directory;
	}
}

export default DirectoryFactory;